import React, { useEffect, useState } from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import chartIcon from '../../../img/icons/chart-icon.svg'
import linkArrowIcon from '../../../img/icons/link-arrow-icon.svg'

import './NavBar.less';

import { navbarRoutes } from '../../routes';
import moment from 'moment';

function mapSubRoutes(subRoutes, nestLevel = 1) {
  return subRoutes.map((route, i) => {
    const isHidden = false;

    if (isHidden) return null;

    return (
      <React.Fragment key={`${route.id}-nav-sub`}>
        <NavSubItem onClick={route.onClick ?? null} style={{ marginLeft: nestLevel * 8 }} path={route.path}>{route.title}</NavSubItem>
        {route.subRoutes && mapSubRoutes(route.subRoutes, nestLevel + 1)}
      </React.Fragment>
    );
  });
}

function NavMainItem(props) {
  return (
    <li>
      <NavLink to={props.path} exact={props.exact} key={props.id} id={props.id}>
        {props.title}
      </NavLink>
    </li>
  );
}

export function NavSubItem(props) {
  const innerItem = props.inactive
    ? props.children
    : props.path || !props.onClick
      ? <NavLink exact={props.exact} to={props.path}>{props.children}</NavLink>
      : <span onClick={props.onClick}>{props.children}</span>;

  return (
    <li style={{ ...styledSubtitle, ...props.style }} className="subtitle">
      {innerItem}
    </li>
  );
}

export default function NavBar({ userCtx }) {
  const [statistics, setStatistics] = useState({today: 0, total: 0})

  useEffect(() => {
    const getStatistics = () => {
      fetch('https://data-api.my1.urfu.ru/api/bi/r/serviceActivity?service=priority2030')
        .then(res => res.json())
        .then(statistics => setStatistics({
          today: statistics.values.find(value => value.date ===  moment().format('DD.MM.YYYY'))?.value || 0,
          total: statistics.total
        }))
    }
    getStatistics()
  }, []);

  return (
    <nav className="navbar">
      <div className="statistics">
        <NavLink to='/statistics'>
          <div className="statistics-link d-flex mb-2 justify-content-between align-items-center">
            <img src={chartIcon} alt=""/>
            <p>Пользователей</p>
            <img src={linkArrowIcon} alt=""/>
          </div>
        </NavLink>
        <div className="statistics-values d-flex gap-1 justify-content-between">
          <span style={{ color: 'white' }}>за сегодня<b className="ms-1">{statistics.today}</b></span>
          <span style={{ color: 'white' }}>всего<b className="ms-1">{statistics.total}</b></span>
        </div>
      </div>
      <ul>
        {navbarRoutes.map((item, i) => {
          // (!item.hideMenu || !item.hideMenu(props.userCtx.perms)) &&
          if (item.hide && item.hide(userCtx)) return null;
          item.subRoutes = item.subRoutes?.filter((s) => !s.hide || !s.hide(userCtx));
          return (
            <React.Fragment key={`${item.id}-nav-main`}>
              <NavMainItem exact={!!(item.navItem || item.subRoutes)} path={item.path} id={item.id} title={item.title} />
              {item.navItem && <item.navItem />}
              {item.subRoutes && !item.navItem && mapSubRoutes(item.subRoutes)}
            </React.Fragment>
          );
        })}
      </ul>
    </nav>
  );
}

const styledSubtitle = {
  fontSize: 12, paddingRight: 8, marginTop: 8, marginBottom: 8,
};
